import React from 'react';
import JsxHelper from '../Helpers/JsxHelper';
import FaIcon from './FaIcon';
import RoleService from '../Services/roleService';

class ButtonWithIcon extends React.Component {
  static defaultProps = {
    className: '',
    value: 'default label',
    onClick: null,
    iconName: 'fa-solid fa-circle',
    disabled: false,
    iconOnRight: false,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    if (this.props.roleKey && !RoleService.CheckUserPermission('buttonWithIcon', this.props.roleKey)) {
      return null;
    }

    let className = this.props.className;
    if (this.props.disabled) {
      className += ' disabledbutton';
    }

    return (
      <span
        className={className}
        onClick={() => {
          if (!this.props.disabled) {
            this.props.onClick();
          }
        }}
      >
        {!this.props.iconOnRight && <FaIcon iconName={this.props.iconName} />}
        {!this.props.iconOnRight && JsxHelper.NonBreakableSpace()}
        {this.props.value}
        {this.props.iconOnRight && JsxHelper.NonBreakableSpace()}
        {this.props.iconOnRight && <FaIcon iconName={this.props.iconName} />}
      </span>
    );
  }
}

export default ButtonWithIcon;
